import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  successMessage: undefined,
  errorMessage: undefined,
};

const drmCoupaDeleteSlice = createSlice({
  name: "drmCoupaDelete",
  initialState,
  reducers: {
    deleteCoupaFilesStart: (state) => {
      state.isLoading = true;
      state.successMessage = undefined;
      state.errorMessage = undefined;
    },
    deleteCoupaFilesSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    deleteCoupaFilesFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    resetDeleteCoupaFilesState: () => ({ ...initialState }),
  },
});

export const {
  deleteCoupaFilesStart,
  deleteCoupaFilesSuccess,
  deleteCoupaFilesFailure,
  resetDeleteCoupaFilesState,
} = drmCoupaDeleteSlice.actions;

export default drmCoupaDeleteSlice.reducer;
